import React from "react";
import "./navbar.css";
import { Link } from "react-router-dom";
import logo from "../Images/darazLogo.png";
import dlogo from "../Images/download.png";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BasicPopover from "./BasicPopover";

function NavBar() {
  return (
    <div className="nav">
      {/* part 1 */}
      <div className="navbar--link">
        <p className="popover-btn">
          <BasicPopover title="SAVE MORE ON APP" />
        </p>
        <p className="link-btn">SELL ON DARAZ</p>
        <p className="popover-btn">
          <BasicPopover title="CUSTOMER CARE" />
        </p>
        <p className="popover-btn">
          <BasicPopover title="TRACK MY ORDER" />
        </p>
        <p className="link-btn">
          <Link to="/login">LOGIN</Link>
        </p>
        <p className="link-btn">
          <Link to="/signup">SIGN UP</Link>
        </p>
        <p className="popover-btn">
          <BasicPopover title="LANGUAGE" />
        </p>
      </div>

      {/* part 2 */}
      <div className="navbar">
        <Link to="/">
          <img className="nav--logo" src={logo} alt="" />
        </Link>

        <div className="nav--search">
          <input
            className="searchInput"
            type="text"
            placeholder="Search in Daraz"
          />
          <SearchIcon className="search-logo" />
        </div>

        <div className="nav--optionBasket">
          <ShoppingCartIcon />
        </div>

        {/* marquee */}
        <div className="marquee">
          <div className="marquee--body">
            <div className="navAd-logo">
              <img className="marquee--logo" src={dlogo} alt="" />
            </div>
            <div className="marquee--text">
              <p>Download Daraz APP</p>
              <h2>& GET Rs.200 Off</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavBar;
